// Module
var code = "<md-content> <tmr-login login-as=\"$ctrl.loginModalUsername\" logged-user=\"$ctrl.loggedUser\" on-submit=\"$ctrl.close()\"></tmr-login> </md-content> ";
// Exports
var _module_exports =code;;
var path = 'components/modals/loginModal/loginModal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;